module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "ebook-toc-1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Disclaimer")]), _vm._v(" "), _c('p', {
    staticClass: "Intro-text-first-paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The recipes and in")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("formation ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" in this book are meant to")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v(" inspire. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" This content is not")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v(" meant to ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" diagnose or treat any")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v(" ailment. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Please consult a physician or clinical herbalist before begi")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("nning any ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" new herbal")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v(" routine. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Intro-text top1 ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When foraging for herb")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("s, please ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" consult a professional before consumption. This")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v(" cookbook ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" is not a foraging ")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("guidebook ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" and canno")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("t be held ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" responsibl")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("e for any ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" mistake")]), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("s made in ")]), _c('span', {
    staticClass: "CharOverride-1"
  }), _c('span', {
    staticClass: "no-break CharOverride-1"
  }, [_vm._v("the wild. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1pagebreak"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4101e284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForestHome_ebook1.vue
// module id = 63
// module chunks = 0